import { computed, inject, Injectable, Signal } from "@angular/core";

import { ConfigService } from "../config-services/config.service";
import { DomainProfile } from "../domain-profile-services/models/domain-profile-data";
import { IAppData } from "./app.factory";
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

@Injectable({
    providedIn: 'root'
})
export class AppService implements IAppData {
    private readonly __configService = injectRequired(ConfigService);

    title$$ = computed(() => this.__configService.logo_name$$() ? this.__configService.app_title$$() : null);
    sutTitle$$ = computed(() => this.__configService.logo_name$$() ? this.__configService.app_subTitle$$() : null);
    version$$ = computed(() => this.__configService.logo_name$$() ? this.__configService.app_version$$() : null);
    versionDetail$$ = computed(() => this.__configService.logo_name$$() ? this.__configService.app_versionDetail$$() : null);
    logos_folderName$$ = computed(() => this.__configService.logo_name$$() ? this.__configService.logos_folderName$$() : null);
    logo_fileName$$ = computed(() => this.__configService.logo_name$$() ? this.__configService.logo_fileName$$() : null);
    logoEmail_fileName$$ = computed(() => this.__configService.logo_name$$() ? this.__configService.logoEmail_fileName$$() : null);
    logoThumb_fileName$$ = computed(() => this.__configService.logo_name$$() ? this.__configService.logoThumb_fileName$$() : null);
    logoIconAppleTouch_fileName$$ = computed(() => this.__configService.logo_name$$() ? this.__configService.logoIconAppleTouch_fileName$$() : null);
    logoIcon_fileName$$ = computed(() => this.__configService.logo_name$$() ? this.__configService.logoIcon_fileName$$() : null);
    logoIconPng_fileName$$ = computed(() => this.__configService.logo_name$$() ? this.__configService.logoIconPng_fileName$$() : null);
    logoIconSvg_fileName$$ = computed(() => this.__configService.logo_name$$() ? this.__configService.logoIconSvg_fileName$$() : null);

    domainProfile$$: Signal<DomainProfile | null> = computed(() => DomainProfile.create(this));
}
